import React from 'react';

const Video = ({
    description,
    path,
}) => {
    return (
        <div className='video flex col gap-sm wrap'>
            { path.length > 15 &&
                <video src={path} volume={0.5} controls>
                    Error loading the video...
                </video>
            }
            { path.length < 15 &&
                <video src={'/videos/' + path} volume={0.5} controls>
                    Error loading the video...
                </video>
            }
            <p>{description}</p>
        </div>
    );
};

export default Video;